const PREFIX = 'POS_TEACHER';

export const SET_TEACHER = `${PREFIX}_SET_TEACHER`;
export const SET_STUDENTS = `${PREFIX}_SET_STUDENTS`;
export const SET_LOADING = `${PREFIX}_SET_LOADING`;
export const SET_WRITING = `${PREFIX}_SET_WRITING`;
export const SET_ERROR = `${PREFIX}_SET_ERROR`;

export const TOGGLE_FOR_CHECKOUT = `${PREFIX}_TOGGLE_FOR_CHECKOUT`;
export const TOGGLE_ALL_FOR_CHECKOUT = `${PREFIX}_TOGGLE_ALL_FOR_CHECKOUT`;

export const CHECKOUT = `${PREFIX}_CHECKOUT`;
export const REMOVE_STUDENT = `${PREFIX}_REMOVE_STUDENT`;

export const RESET = `${PREFIX}_RESET`;
export const SET_STUDENT_ERROR = `${PREFIX}_SET_STUDENT_ERROR`;

export const ADD_ITEM = `${PREFIX}_ADD_ITEM`;
export const ADD_ITEM_TO_STUDENTS = `${PREFIX}_ADD_ITEM_TO_STUDENTS`;

export const RESET_ALL_STUDENTS_BOUGHT_ITEMS = `${PREFIX}_RESET_ALL_STUDENTS_BOUGHT_ITEMS`;
export const RESET_ALL_STUDENTS_SELECTED = `${PREFIX}_RESET_ALL_STUDENTS_SELECTED`;
export const RESET_STUDENT_BOUGHT_ITEMS = `${PREFIX}_RESET_STUDENT_BOUGHT_ITEMS`;
export const RESET_STUDENT_SELECTED = `${PREFIX}_RESET_STUDENT_SELECTED`;
export const RESET_ALL_STUDENTS_ERROR = `${PREFIX}_RESET_ALL_STUDENTS_ERROR`;
export const RESET_STUDENT_ERROR = `${PREFIX}_RESET_STUDENT_ERROR`;

export const SET_NUM_PROCESSED = `${PREFIX}_SET_NUM_PROCESSED`;
export const SET_NUM_PROCESSING = `${PREFIX}_SET_NUM_PROCESSING`;

export const SET_SELECT_ALL_STUDENTS = `${PREFIX}_SET_SELECT_ALL_STUDENTS`;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/state/types.js